import { api } from "api";
import type { NonIndexRouteObject } from "react-router-dom";

import InsolvencyMonitorWhitelistRoute from "./InsolvencyMonitorWhitelistRoute";

export const insolvencyMonitorRoute: NonIndexRouteObject = {
  loader: () => api.listWhitelist("insolvency-monitor"),
  element: <InsolvencyMonitorWhitelistRoute />,
};
